// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3yNNo","head":"Table_head__2yI69","col":"Table_col__16_8n"};